import { useContext, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import secureLocalStorage from "react-secure-storage";

import HandleSearch from "../../../utils/CommonSearchComponent";
import { GlobalStateContext } from "../../../utils/GlobalStateContext";

import {
  fetchAuditsThunk,
  fetchDepartmentsThunk,
} from "../../../store/thunks/auditsThunk";

import SearchInput from "../SearchInput";
import media from "../../../media";
import { fetchAuditFormsThunk } from "../../../store/thunks/auditFormsThunk";
import { fetchDeletedAuditsThunk } from "../../../store/thunks/deletedAuditsThunk";
import { fetchClientsThunk } from "../../../store/thunks/clientsThunk";
import { fetchProcessesThunk } from "../../../store/thunks/processesThunk";

/**
 * Pages that use Redux/Thunk based search
 * Add new pages here in future
 */
const THUNK_SEARCH_PAGES = {
  auditForms: {
    thunk: fetchAuditFormsThunk,
  },
  audits: {
    thunk: fetchAuditsThunk,
  },
  "deleted-audits": {
    thunk: fetchDeletedAuditsThunk,
  },
  departments: {
    thunk: fetchDepartmentsThunk,
  },
  processes: {
    thunk: fetchProcessesThunk,
  },
  clients: {
    thunk: fetchClientsThunk,
  },
};

const SearchBar = (props) => {
  const { loc } = props;
  const dispatch = useDispatch();

  const { globalState, setGlobalState } = useContext(GlobalStateContext);

  const [active, setActive] = useState(false);
  const [list, setList] = useState([]);
  const [searchData, setSearchData] = useState([]);
  const [allTransactionIdsArr, setAllTransactionIdsArr] = useState([]);
  const [selectedRowsArray, setSelectedRowsArray] = useState([]);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 50 });
  const [listItems, setListItems] = useState([]);
  const [showLoader, setShowLoader] = useState(true);

  const handleOnChange = async (e) => {
    setShowLoader(true);
    const value = e.target.value || "";
    const searchIn = loc.pathname.replace("/", "");

    let hasSearchedValue = "";
    if (value) {
      hasSearchedValue = "yes";
      secureLocalStorage.setItem("hasSearchedValue", "yes");
      secureLocalStorage.setItem("searchKeyword", value);
    } else {
      secureLocalStorage.removeItem("hasSearchedValue");
      secureLocalStorage.removeItem("searchKeyword");
    }

    // ================================
    // CASE 1: THUNK BASED SEARCH (AUDITS)
    // ================================
    if (THUNK_SEARCH_PAGES[searchIn]) {
      const { thunk } = THUNK_SEARCH_PAGES[searchIn];

      dispatch(
        thunk({
          searchIn,
          callActionFrom: "searchBar",
          hasSearchedValue,
          searchKeyword: value,
          pagination,
        }),
      );

      return;
    }

    // ================================
    // CASE 2: LEGACY SEARCH (OTHERS)
    // ================================
    const globalStates = {
      globalState,
      setGlobalState,
    };

    const allStates = {
      searchData,
      setSearchData,
      selectedRowsArray,
      setSelectedRowsArray,
      allTransactionIdsArr,
      setAllTransactionIdsArr,
      listItems,
      setListItems,
      showLoader,
      setShowLoader,
      pagination,
      setPagination,
      list,
      setList,
    };

    await HandleSearch(
      hasSearchedValue,
      searchIn,
      value,
      "searchBar",
      globalStates,
      allStates,
    );

    setShowLoader(false);
  };

  /**
   * Sync legacy search data to globalState (unchanged behavior)
   */
  useEffect(() => {
    if (Array.isArray(searchData) && searchData.length > 0) {
      setList(searchData);
      setGlobalState((prev) => ({
        ...prev,
        list: searchData,
      }));
    }
  }, [searchData]);

  return (
    <>
      <div className="searchBar-containter">
        <div className="align-items-center d-flex name_search">
          <div className="search-area">
            <div className={`searchInput ${active ? "activeSearch" : ""}`}>
              <SearchInput loc={loc} handleOnChange={handleOnChange} />
              <img
                src={media.searchIcon.svg}
                alt="Search"
                className="searchSymb"
                onClick={() => setActive(!active)}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SearchBar;
